export default "__VITE_ASSET__DMmyy0gQ__"